module.exports = __webpack_public_path__ + "img/DRIVE_MOTORCYCLE.ddc61391.svg";